import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromBasket from './+state/basket.reducer';
import { DevicesEffects } from './+state/devices/devices.effects';
import { QuotesEffects } from './+state/quotes/quotes.effects';
import { BasketApiService } from './services/basket-api.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromBasket.BASKET_FEATURE_KEY,
      fromBasket.basketReducer
    ),
    EffectsModule.forFeature([QuotesEffects, DevicesEffects]),
  ],
  providers: [BasketApiService],
})
export class SkyDataAccessBasketModule {}
